<template lang="pug">
.img.text-center.clickable.vertical-align-top(@click="clicked")
  .img-wrap
    img(:src="product.imagery.squareSwatch.url" :alt="product.imagery.squareSwatch.alt_text" width="126px")
    .pick-wrapper.xs-f-xxsmall.md-f-xsmall.lg-f-xxsmall.max-at-tweak(v-if="isBestOrOtherMatch" :class="{ best: isBestMatch}")
      .pick
      p.pick-text.header.semi-bold(v-if="isBestMatch") best match
      p.pick-text.two.header.semi-bold(v-if="isOtherMatch") match
    span.icon-check.color-white.xs-f-xlarge.md-f-xxlarge.lg-f-xlarge.max-at-tweak(v-if="showCheckIcon")
      span.ada-tooltip check icon
  p.prod-code.xs-f-small.md-f-medium.lg-f-small.max-at-tweak.xs-hide {{product.cleanName}}
  p.prod-code.xs-f-small.md-f-medium.lg-f-small.max-at-tweak.sm-hide.md-hide.lg-hide {{product.color_designator}}
</template>
<script>
  export default {
    name: 'ProductSlide',

    emits: ['deselect', 'select'],
    props: {
      product: {
        type: Object,
        default: () => ({}),
      },
      isBestMatch: {
        type: Boolean,
        default: () => false,
      },
      isOtherMatch: {
        type: Boolean,
        default: () => false,
      },
      showCheckIcon: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      isBestOrOtherMatch() {
        return this.isBestMatch || this.isOtherMatch;
      },
    },
    methods: {
      clicked() {
        if (this.showCheckIcon) {
          this.$emit('deselect');
        } else {
          this.$emit('select');
        }
      },
    },
  };
</script>